import { botApi } from './botApi'
import { makeQueryParamString } from 'utils/utils'
import { IPlaceOrderInputData, ISystemStatus, IWithdrawInputData } from './types'

export const inputDataApi = botApi.injectEndpoints({
  endpoints: ({ query }) => ({
    getMarketsFromTwoExchanges: query<string[], { exchange?: string; secondExchange?: string }>({
      // query: (params: { exchange?: string; secondExchange?: string }) => {
      //   const paramString = makeQueryParamString(params)
      //   return `/inputData/markets?${paramString}`
      // },
      query: (params: { exchange?: string; secondExchange?: string }) => ({
        url: '/inputData/markets',
        params: { ...params },
      }),
    }),
    getInputDataMarketsFiltered: query<string[], { exchange?: string; secondExchange?: string }>({
      query: (params: { exchange?: string; secondExchange?: string }) => {
        const paramString = makeQueryParamString(params)
        return `/inputData/markets?${paramString}`
      },
    }),
    getInputDataSymbols: query<string[], { exchange?: string; secondExchange?: string }>({
      query: (params: { exchange?: string; secondExchange?: string }) => {
        const paramString = makeQueryParamString(params)
        return `/inputData/symbols?${paramString}`
      },
    }),
    getInputDataExchanges: query<string[], any>({
      query: () => '/inputData/exchanges',
    }),
    getInputDataPlaceOrderMarkets: query<IPlaceOrderInputData[], any>({
      query: () => '/inputData/placeOrderFormMarkets',
    }),
    getInputDataWithdrawSymbols: query<IWithdrawInputData, { exchange?: string; secondExchange?: string }>({
      query: (params: { exchange?: string; secondExchange?: string }) => {
        const paramString = makeQueryParamString(params)
        return `/inputData/symbols?${paramString}`
      },
    }),
    getInputDataWithdrawStatuses: query<string[], any>({
      query: () => {
        return `/inputData/withdrawStatuses`
      },
    }),
    getInputDataTOByExchanges: query<string[], any>({
      query: () => {
        return `/inputData/TOExchanges`
      },
    }),
    getInputDataTOByExchangesCEX: query<string[], any>({
      query: () => {
        return `/inputData/TOExchanges/CEX`
      },
    }),
    getInputDataTOByMarkets: query<string[], any>({
      query: () => {
        return `/inputData/TOMarkets`
      },
    }),
    getInputDataTOBySymbols: query<string[], any>({
      query: () => {
        return `/inputData/TOSymbols`
      },
    }),
    getSemaphoreBanList: query<string[], any>({
      query: () => {
        return `/inputData/semaphoreInfo`
      },
    }),
    enableSemaphore: query<string, { enable: boolean }>({
      query: (params: { enable: boolean }) => {
        const paramString = makeQueryParamString(params)
        return `/inputData/semaphoreEnable?${paramString}`
      },
    }),
    getSemaphoreStatus: query<boolean, any>({
      query: () => {
        return `/inputData/semaphoreState`
      },
    }),
    getSystemStatus: query<ISystemStatus, any>({
      query: () => {
        return `/inputData/systemStatus`
      },
    }),
    getTradeOptionsIdsByMarkets: query<{ idByKey: string[][] }, any>({
      query: () => {
        return `/inputData/tradeOptionIdsByMarket`
      },
    }),
  }),
})

export const {
  useGetInputDataWithdrawSymbolsQuery,
  useGetMarketsFromTwoExchangesQuery,
  useLazyGetMarketsFromTwoExchangesQuery,
  useLazyGetInputDataSymbolsQuery,
  useGetInputDataSymbolsQuery,
  useGetInputDataExchangesQuery,
  useGetInputDataTOByExchangesCEXQuery,
  useLazyGetInputDataExchangesQuery,
  useLazyGetInputDataPlaceOrderMarketsQuery,
  useLazyGetInputDataWithdrawSymbolsQuery,
  useGetInputDataMarketsFilteredQuery,
  useLazyGetInputDataMarketsFilteredQuery,
  useGetInputDataWithdrawStatusesQuery,
  useGetInputDataTOByExchangesQuery,
  useGetInputDataTOByMarketsQuery,
  useGetInputDataTOBySymbolsQuery,
  useGetSemaphoreBanListQuery,
  useLazyEnableSemaphoreQuery,
  useGetSemaphoreStatusQuery,
  useGetSystemStatusQuery,
  useGetTradeOptionsIdsByMarketsQuery,
} = inputDataApi
